import React from "react";

export default ({ children, className }) => {
	return (
		<div className={`ActionBar font--body--alt ${className}`}>
			{children}
		</div>
	)
}